import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { COMPANY } from "../data/content";

export const WhatsAppButton = () => {
  return (
    <a
      href={COMPANY.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="relative flex items-center gap-3">
        <span className="hidden md:inline-flex items-center gap-2 bg-[var(--sifra-ink)] text-white px-4 py-2 text-xs tracking-label font-semibold uppercase opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300">
          Chat Now
        </span>
        <span className="relative wa-ring inline-flex w-14 h-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(37,211,102,0.45)] hover:bg-[#1EBE5D] transition-transform duration-300 group-hover:scale-105">
          <WhatsappLogo size={28} weight="fill" />
        </span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
